// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'

import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'

import MascotGrid from '../mascotgrid/index.js'
import AppPromo from '../apppromotion/index.js'
import * as isTouch from 'has-touch'

import 'styles/App.css'
import './styles.scss'

const MascotData = require('./data-mascots.csv')
// import MascotData from './data-mascots.csv'

type Props = {
  articleId: number
}

type State = {
  flippedCard: number,
  mascotData: []
}

const ADDITIONAL_SHARES = 533

export default class AppComponent extends React.Component<Props, State> {
  static defaultProps = {
    articleId: 23192502
  }

  state: State = {
    flippedCard: -1
  }

  componentDidMount() {
    let mascotDataArray = []
    MascotData.forEach(function(mascot) {
      if (mascot.show !== 'no') {
        mascotDataArray.push(mascot)
      }
    })
    const shuffleArray = array => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        array[j].id = i
        ;[array[i], array[j]] = [array[j], array[i]]
      }
    }
    shuffleArray(MascotData)
    this.setState({
      mascotData: mascotDataArray
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={this.props.articleId} enablePaywall={false} />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Erkennen Sie die Schweizer Stadt?
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Wir zeigen Ihnen zwölf Umrisskarten, die Schweizer Städte von
                oben zeigen. Wissen Sie, um welche es sich handelt?
              </div>
            </h2>
            <p className='ta author'>
              <strong>Von Patrick Vögeli und Paul Schneeberger</strong>
            </p>
          </div>
        </header>

        <div className='ui text container'>
          <p className='first-mascot-container'>
            In unserem Quiz zeigen wir die Städte als sogenannte Schwarzpläne.
            Dafür haben wir Strassen, Vegetation und Gewässer ausgeblendet, um
            die Struktur der Bebauung sichtbar zu machen. Durch historische
            Entwicklungen oder gezielte Stadtplanung hat jede Stadt einen
            individuellen «Abdruck» erhalten. Im Folgenden sehen Sie diese
            ungewohnten Ansichten und dürfen raten, um welche Städte es sich
            handelt. Zu jedem Kartenausschnitt geben wir jeweils einen Tipp.
          </p>
        </div>

        {
          // App-Promotion
          /*
        (browserCheck.isMobile || browserCheck.isTablet) &&
          parseHostname().publicationName === 'tagesanzeiger' && (
            <AppPromo
              text='Haben Sie unsere App schon installiert?'
              linktext='Hier herunterladen'
              waypoint='Link Click Element'
              url='https://cd4mj.app.goo.gl/2Qah'
            />
          )
          */
        }

        <div
          className='ui vertical inverted segment infoContainer'
          style={{ backgroundColor: '#353535' }}
        >
          <div className='ui text container'>
            <div className='howToDiv'>
              {isTouch && (
                <span>
                  <i className='icon hand pointer' />
                  Tippen Sie auf eine Stadt, um die Lösung zu erfahren.
                </span>
              )}
              {!isTouch && (
                <span>
                  <i className='icon mouse pointer' />
                  Fahren Sie über eine Stadt, um die Lösung zu erfahren.
                </span>
              )}
            </div>
            <div className='scaleDiv'>
              <img className='scale' src={require('./scale.svg')} />
            </div>
          </div>
        </div>

        <main
          className='ui vertical inverted segment mascot-segment'
          style={{ paddingBottom: '0' }}
        >
          <MascotGrid
            elementsPerRowDesktop='five'
            elementsPerRowMobile='eight'
            mascotData={MascotData}
          />
        </main>

        <Footer
          credits={[
            [
              'Konzept und Programmierung',
              'Patrick Vögeli, Sebastian Broschinski'
            ],
            ['Texte', 'Paul Schneeberger, Schweizerischer Städteverband'],
            [
              'Inspiration und Quellen',
              '<a href="http://hanshack.com/" target="blank"> hanshack.com </a> | © <a href="http://openstreetmap.org/copyright" target="blank">OpenStreetMap</a> contributors'
            ]
          ]}
          questions={[
            'Wie unterhaltsam war das Quiz?',
            'Wie gefällt Ihnen die Gestaltung?',
            'Funktionierte die technische Umsetzung?'
          ]}
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          invertedTop
          topHalfClassName='grey'
          hideUserFeedback
          starColor='yellow'
        />
      </div>
    )
  }
}
